module.exports = __webpack_public_path__ + "img/article-header-preview-4.d9344308.jpg";